import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface DeviceTypeProps {
  open: boolean;
  handleClose: () => void;
  deviceTypeName: any;
  SetDeviceTypeName: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  SetAdwordsValue: any;
  adwordsValue: any;
  selectedRowData: any;
  setSelectedRowData: any;
  setMetaDeviceType: any;
}

function EditDeviceTypeModal({
  open,
  handleClose,
  deviceTypeName,
  SetDeviceTypeName,
  selectedShareuid,
  SetAdwordsValue,
  adwordsValue,
  selectedRowData,
}: DeviceTypeProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const UpdateNewDeviceType = async () => {
    const data = {
      device_type_name: deviceTypeName,
      adwords_value: adwordsValue,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaDeviceType(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
      } else {
        throw new Error("User doesn't have permissions to create Devie Type");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaDeviceType(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaDeviceType(
        oauthTokenHeader,
        dispatch
      );
    }
  };

  useEffect(() => {
    if (oauthTokenHeader) {
      SetDeviceTypeName(selectedRowData?.device_type_name);
      SetAdwordsValue(selectedRowData?.adwords_value);
    }
  }, [selectedRowData, SetDeviceTypeName, SetAdwordsValue, oauthTokenHeader]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit New DeviceType
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={6}>
                <TextField
                  value={deviceTypeName}
                  id="outlined-multiline-flexible"
                  label="Device Type *" // Set your label here
                  placeholder="Enter unique Device Type Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  onChange={(e: any) => SetDeviceTypeName(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={adwordsValue}
                  id="outlined-multiline-flexible"
                  label="Adwords Value *" // Set your label here
                  placeholder="Enter unique Adwords Value" // Set your placeholder here
                  color="secondary"
                  size="small"
                  onChange={(e: any) => SetAdwordsValue(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              All fields are mandatory.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!deviceTypeName || !adwordsValue}
                onClick={UpdateNewDeviceType}
                data-tracker="235"
              >
                Save changes <SaveOutlinedIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditDeviceTypeModal;
